import React, { useEffect, useState } from 'react';
import {
	InputSearchGray,
	Layout,
	ScrollItemLearning,
} from '../../../components';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ScrollItemEvent from '../../../components/moleculs/ScrollItem/ScrollItemEvent';
import {
	postDataPage,
	setPageNo,
	setPageSize,
} from '../../../redux/learningsSlice';

const Learning = () => {
	const { category } = useParams();
	const [searchParams, setSearchParams] = useSearchParams();
	const [keyword, setKeyword] = useState(searchParams.get('keyword') || '');

	const dispatch = useDispatch<any>();

	const getLearningList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content_plain',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};

		if (category) {
			const filter_category = {
				key: 'learningCategory.slug',
				value: category,
				operation: 'EQUAL',
				conjunction: 'and',
			};

			params.filter.push(filter_category);
		}
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	useEffect(() => {
		getLearningList(0, 10);
	}, []);

	return (
		<Layout
			title={category ? `Learning - ${category}` : `All Learning`}
			showNavBar={true}
			showNavigation={false}
		>
			<div className="mt-[4rem]">
				<div className="flex gap-5 justify-between items-center ">
					<InputSearchGray
						value={keyword}
						onChange={(e) => {
							setKeyword(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								getLearningList(0, 10);
							}
						}}
						icon={'FaSistrix'}
						placeholder="Cari Informasi Berita"
					/>
				</div>
				<div className="mt-5">
					<ScrollItemLearning
						keyword={keyword}
						fix={false}
					/>
				</div>
			</div>
		</Layout>
	);
};

export default Learning;
